import { render, staticRenderFns } from "./view.vue?vue&type=template&id=d2a48234&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style0 from "./view.vue?vue&type=style&index=0&id=d2a48234&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a48234",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2a48234')) {
      api.createRecord('d2a48234', component.options)
    } else {
      api.reload('d2a48234', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=d2a48234&scoped=true", function () {
      api.rerender('d2a48234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/delivery/result/view.vue"
export default component.exports